function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var FlightFilled = function FlightFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#242328",
    fillRule: "evenodd",
    d: "M20.975 2.893a1.7 1.7 0 0 0-1.02-.392c-.417-.015-.879.117-1.42.393-1.037.528-2.53 1.675-4.84 3.813L5.5 3.489a1 1 0 0 0-1.025.178l-1.29 1.13a1 1 0 0 0 .142 1.61l6.756 4.075-3.125 3.53H4.395a.5.5 0 0 0-.355.148l-1.395 1.403a.5.5 0 0 0 .158.812l3.333 1.428 1.373 3.385a.5.5 0 0 0 .817.166l1.661-1.657a.5.5 0 0 0 .146-.393l-.185-2.38 3.42-3.176 3.749 6.45a1 1 0 0 0 1.573.203l1.176-1.183a1 1 0 0 0 .23-1.05l-2.924-7.948c2.281-2.31 3.46-3.8 3.977-4.84.27-.543.384-1.01.343-1.431-.043-.433-.241-.745-.444-.986a.5.5 0 0 0-.073-.07",
    clipRule: "evenodd"
  }));
};
export default FlightFilled;
FlightFilled.displayName = 'FlightFilled';